export default __webpack_public_path__ + "static/x_connectpr-134d6c90c911956d4b5c3b7af9088794.svg";